/** Marks portal constants — exam-driven + standalone */

export const ASSIGNMENT_STATUSES = [
  "PENDING",
  "IN_PROGRESS",
  "SUBMITTED",
  "LOCKED",
];

export const ASSIGNMENT_STATUS_LABELS = {
  PENDING: "Pending",
  IN_PROGRESS: "In Progress",
  SUBMITTED: "Submitted",
  LOCKED: "Locked",
};

export const ASSIGNMENT_STATUS_COLORS = {
  PENDING: "bg-gray-100 text-gray-600",
  IN_PROGRESS: "bg-yellow-100 text-yellow-800",
  SUBMITTED: "bg-blue-100 text-blue-700",
  LOCKED: "bg-red-100 text-red-700",
};

export const STANDALONE_SCHEME_TYPES = [
  "ASSIGNMENT",
  "ACTIVITY",
  "CLUB",
  "GAME",
  "PROJECT",
  "CUSTOM",
];

export const STANDALONE_SCHEME_TYPE_LABELS = {
  ASSIGNMENT: "Assignment",
  ACTIVITY: "Activity",
  CLUB: "Club",
  GAME: "Game",
  PROJECT: "Project",
  CUSTOM: "Custom",
};

export const isAssignmentLocked = (status) =>
  status === "SUBMITTED" || status === "LOCKED";
